import { LoginUser, RawUser }           from '../models/User';
import { ADMIN_ROLE_ID, ADMIN_USER_ID } from '../consts/user';

export const calculatePermissions = (rawUser: RawUser): LoginUser => {
  const concatArrays = <T extends Number | String>(arrayFrom: T[], arrayTo: T[]): void =>
    arrayFrom.forEach((element) => arrayTo.indexOf(element) === -1 && arrayTo.push(element));

  const user = { ...rawUser };

  (user as LoginUser).permissions = {};

  (rawUser.rolesPermissions || []).forEach((rolePermissions) => {
    const keys = Object.keys(rolePermissions || {});

    keys.forEach((key) => {
      try {
        const userKeyValue = (user as LoginUser).permissions![key] || 0;
        const rolePermissionsKeyValue = rolePermissions[key];

        if (typeof userKeyValue !== 'number' || typeof rolePermissionsKeyValue !== 'number') {
          throw new Error(`Role permission field '${key}' must be a number!`);
        } else {
          const userCrud = userKeyValue.toString(2).padStart(4, '0').split(''),
                roleCrud = rolePermissionsKeyValue.toString(2).padStart(4, '0').split('');

          for (let i = 0; i < userCrud.length; i++) {
            userCrud[i] = `${+userCrud[i] | +roleCrud[i]}`;
          }

          (user as LoginUser).permissions![key] = parseInt(userCrud.join(''), 2);
        }
      } catch (e) {
        (user as LoginUser).permissions![key] = 0;
        console.log(e);
      }
    })
  });

  (user as LoginUser).roleSettings = {};

  (rawUser.rolesSettings || []).forEach((roleSettings) => {
    const keys = Object.keys(roleSettings || {});

    keys.forEach((key) => {
      try {
        const userKeyValue = (user as LoginUser).roleSettings![key];
        const roleSettingsKeyValue = roleSettings[key];

        switch (key) {
          case 'pdm_tree_nodes_limit':
            if (!userKeyValue) {
              if (!Array.isArray(roleSettingsKeyValue.nodes)) {
                throw new Error(`Role setting field '${key}' must be a array!`);
              } else {
                (user as LoginUser).roleSettings![key] = roleSettingsKeyValue.nodes;
              }
            } else {
              if (!Array.isArray(roleSettingsKeyValue.nodes) || !Array.isArray(userKeyValue)) {
                throw new Error(`Role setting field '${key}' must be a array!`);
              } else {
                concatArrays<string>(roleSettingsKeyValue.nodes, userKeyValue);
              }
            }
            break;
          case 'camera_type':
          case 'smsv_moderation_statuses':
            if (!userKeyValue) {
              if (!Array.isArray(roleSettingsKeyValue)) {
                throw new Error(`Role setting field '${key}' must be a array!`);
              } else {
                (user as LoginUser).roleSettings![key] = roleSettingsKeyValue;
              }
            } else {
              if (!Array.isArray(roleSettingsKeyValue) || !Array.isArray(userKeyValue)) {
                throw new Error(`Role setting field '${key}' must be a array!`);
              } else {
                concatArrays<number>(roleSettingsKeyValue, userKeyValue);
              }
            }
            break;
          default:
            if (!userKeyValue) {
              if (typeof roleSettingsKeyValue !== 'number') {
                throw new Error(`Role setting field '${key}' must be a number!`);
              } else {
                (user as LoginUser).roleSettings![key] = roleSettingsKeyValue;
              }
            } else {
              if (typeof userKeyValue !== 'number' || typeof roleSettingsKeyValue !== 'number') {
                throw new Error(`Role setting field '${key}' must be a number!`);
              } else if (userKeyValue < roleSettingsKeyValue) {
                (user as LoginUser).roleSettings![key] = roleSettingsKeyValue;
              }
            }
        }
      } catch (e) {
        if (key === 'pdm_tree_nodes_limit' || key === 'camera_type') {
          (user as LoginUser).roleSettings![key] = [];
        } else {
          (user as LoginUser).roleSettings![key] = 0;
        }
        console.log(e);
      }
    })
  });

  delete user.rolesPermissions;
  delete user.rolesSettings;

  return user;
};

export const isAdminRole = (roleId: number) => roleId === ADMIN_ROLE_ID;
export const isAdminUser = (userId: number) => userId === ADMIN_USER_ID;